export default __webpack_public_path__ + "static/media/CrearfirmaICO.ecb9e804.svg";